<div class="container">
  <app-template [title]="'Receipt Template'">
        <form [formGroup]="templateForm" (ngSubmit)="onSubmit($event)">
          <div class="form">
              <span class="input">
                  <mat-form-field>
                      <mat-label>Subject</mat-label>
                      <input formControlName="Name" matInput placeholder="">
                    </mat-form-field>
                </span>
                <div class="space"></div>
              <!-- <quill-editor formControlName="Template_Text" [styles]="{height: '300px'}"></quill-editor> -->
              <angular-editor [config]="editorConfig" [placeholder]="'Enter text here...'" formControlName="Template_Text"></angular-editor>
              <div class="errorMessage">
                  <div *ngIf="Errors" class="error">
                      <p>{{Errors}}</p>
                  </div>
              </div>
              <button class="create" *ngIf="!isLoading" mat-raised-button color="primary"> Send</button>
              <button class="create" *ngIf="isLoading" mat-raised-button color="primary"> <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></button>
              <div class="space"></div>
          </div>

      </form>

  </app-template>
</div>
